export default __webpack_public_path__ + "static/media/recent2.8837cd27.png";